import React from 'react';
import Icon from 'components/AppIcon';
import DealCard from './DealCard';
import { STAGES } from './pipelineData';

function KanbanColumn({ stage, deals, onMoveStage, onToggleFlag, onAddToast, onAddDeal }) {
  const totalValue = deals?.reduce((sum, d) => sum + (d?.ticketSize || 0), 0);

  return (
    <div className="flex-shrink-0 w-72 flex flex-col" style={{ minHeight: 0 }}>
      <div
        className="rounded-t-xl px-4 py-3 border border-b-0"
        style={{ background: stage?.headerBg, borderColor: stage?.border }}
      >
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ background: stage?.color }} />
            <span className="font-semibold text-slate-800 text-sm">{stage?.label}</span>
          </div>
          <span
            className="inline-flex items-center justify-center w-5 h-5 rounded-full text-xs font-bold text-white"
            style={{ background: stage?.color }}
          >
            {deals?.length}
          </span>
        </div>
        <div className="mt-1 text-xs text-slate-500">
          Total: <span className="font-semibold text-slate-700">{String.fromCharCode(163)}{totalValue}m</span>
        </div>
      </div>

      <div
        className="flex-1 rounded-b-xl border border-t-0 p-3 space-y-3 overflow-y-auto"
        style={{ background: '#f8fafc', borderColor: stage?.border, maxHeight: 'calc(100vh - 280px)' }}
      >
        {deals?.length === 0 && (
          <div className="flex flex-col items-center justify-center py-8 text-center">
            <div className="w-10 h-10 rounded-full flex items-center justify-center mb-2" style={{ background: stage?.bg }}>
              <Icon name="Inbox" size={18} color={stage?.color} />
            </div>
            <p className="text-xs text-slate-400">No deals in this stage</p>
          </div>
        )}
        {deals?.map((deal) => (
          <DealCard
            key={deal?.id}
            deal={deal}
            onMoveStage={onMoveStage}
            onToggleFlag={onToggleFlag}
            onAddToast={onAddToast}
          />
        ))}
        <button
          onClick={() => onAddDeal?.(stage?.id)}
          className="w-full border-2 border-dashed border-slate-300 rounded-xl py-3 text-xs text-slate-400 hover:border-slate-400 hover:text-slate-500 hover:bg-white transition-all duration-200 flex items-center justify-center gap-1.5"
        >
          <Icon name="Plus" size={14} />
          Add deal
        </button>
      </div>
    </div>
  );
}

export default function KanbanBoard({ deals, onMoveStage, onToggleFlag, onAddToast, onAddDeal }) {
  return (
    <div className="overflow-x-auto pb-4">
      <div className="flex gap-4" style={{ minWidth: 'max-content' }}>
        {STAGES?.map((stage) => {
          const stageDeals = deals?.filter((d) => d?.stage === stage?.id);
          return (
            <KanbanColumn
              key={stage?.id}
              stage={stage}
              deals={stageDeals}
              onMoveStage={onMoveStage}
              onToggleFlag={onToggleFlag}
              onAddToast={onAddToast}
              onAddDeal={onAddDeal}
            />
          );
        })}
      </div>
    </div>
  );
}
